import React, { Fragment } from 'react';
import YouTubePlayer from 'react-player/lib/players/YouTube';
import { string } from 'prop-types';
import './index.css';

const DEFAULT_WIDTH = 480;
const DEFAULT_HEIGHT = 270;

const VideoPlayer = ({ youtubeId, thumbnail, title, ...rest }) => {
  const videoUrl = youtubeId
    ? `https://www.youtube.com/watch?v=${youtubeId}`
    : rest.url;
  const size = {
    width: thumbnail ? DEFAULT_WIDTH / 2 : DEFAULT_WIDTH,
    height: thumbnail ? DEFAULT_HEIGHT / 2 : DEFAULT_HEIGHT,
  };

  const Player = () => (
    <YouTubePlayer controls url={videoUrl} {...size} {...rest} />
  );

  // only display the image in thumbnail mode
  if (thumbnail) {
    return (
      <Fragment>
        <img style={size} src={thumbnail} />
        <h3 className="vplayer__title">{title}</h3>
      </Fragment>
    );
  }

  // display title under the video
  if (title) {
    return (
      <Fragment>
        <Player />
        <h3 className="vplayer__title">{title}</h3>
      </Fragment>
    );
  }

  return <Player />;
};

VideoPlayer.propTypes = {
  youtubeId: string,
  url: string,
  title: string,
  thumbnail: string,
};

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/common/components/VideoPlayer/index.js